import React, { useState, ChangeEvent } from 'react';
import { TextInput } from './ImportProject.style';

interface TextInputProps {
    defaultValue: string | null;
    placeholder?: string;
    onChange: (value: string) => void;
    type?: string;
    disabled?: boolean;
    error?: boolean;
}

export const Input: React.FC<TextInputProps> = ({ defaultValue, placeholder, onChange, disabled, error, type = 'text' }) => {
    const [value, setValue] = useState<string>(defaultValue ?? '');

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
        onChange(inputValue);
    };

    return (
        <TextInput
            disabled={disabled}
            type={type}
            error={error}
            value={value}
            placeholder={placeholder}
            onChange={handleChange}
        />
    );
};
